import fr from 'facet-rest';
import { useModalViewContext } from 'Views/Onboarding/Contexts/ModalViewContext';
import { useOnboardingPlannerViewContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContext';

export default function useViewAllAccountsListItem(lineItemResource) {
  const { openSurvey } = useOnboardingPlannerViewContext();
  const { handleHideModal } = useModalViewContext();

  const handleClick = () => {
    handleHideModal();
    return openSurvey(lineItemResource.relationship(fr.relationships.institution.name).link('related').url(), 'onboardingBalanceSheet');
  };

  return {
    handleClick,
  };
}
